import type { SellerAccountBlockCabinetReason } from './seller-account-block.types';

/** Подписи причин блокировки кабинета (совпадают с текстами для супер-админа). */
export const SELLER_ACCOUNT_BLOCK_REASON_LABELS: Record<
  SellerAccountBlockCabinetReason,
  string
> = {
  RUDE_CUSTOMER_CONTACT: 'Некорректное общение с покупателем (до выяснения обстоятельств)',
  FAKE_ORDERS: 'Фиктивные заказы (до выяснения обстоятельств)',
  SYSTEMATIC_RULE_VIOLATION: 'Систематическое нарушение правил (блокировка без срока)',
  REPEATED_INACTION_ORDER_AUTO_CANCEL:
    'Повторная автоотмена: заказы не переводились в работу в срок (блокировка 2 суток)',
  REPEATED_LOW_RATING_ORDERS:
    'Три заказа подряд с рейтингом ниже 3 звёзд (эскалация: 2 дня, 7 дней, затем навсегда)',
};
